module.exports = __webpack_public_path__ + "img/plus.13dccd67.svg";